const emotions = {
  name: "Emotions",
  prompts: [
    "Anxiety",
    "Worry",
    "Discomfort",
    "Comfort",
    "Hopeful",
    "Confident",
    "Ennui",
    "Boredom",
    "Indifference",
    "Interest",
    "Curiosity",
    "Intrigue",
    "Frustration",
    "Puzzlement",
    "Confusion",
    "Insight",
    "Enlightenment",
    "Epiphany",
    "Dispirited",
    "Disappointed",
    "Dissatisfied",
    "Satisfied",
    "Thrilled",
    "Enthusiastic",
    "Terror",
    "Dread",
    "Apprehension",
    "Calm",
    "Cosy",
    "Anticipatory",
    "Excited",
    "Humiliated",
    "Embarrassed",
    "Self-conscious",
    "Pleased",
    "Satisfied",
    "Proud",
  ],
};

export default emotions;
